import React, { useContext, useEffect, useState } from 'react';
import { Icon, Text } from '@fluentui/react';
import { 
    AzureDataPosition, 
    AzureMapFeature, 
    AzureMapHtmlMarker, 
    AzureMapLayerProvider, 
    AzureMapPopup, 
    AzureMapsContext, 
    IAzureMapsContextProps, 
} from 'react-azure-maps';

import ItemRegistroTiempo from '../../models/ItemRegistroTiempo';

const getLatLng = (value: string) : AzureDataPosition => {
    const valueArray : string[] = value.split(',');
    return [
        parseFloat(valueArray[1]),
        parseFloat(valueArray[0]),
    ];
};

interface IAzureMapMarkerComponentProps {
    workPart: ItemRegistroTiempo;
    selectedWorkPart?: ItemRegistroTiempo;
    selectedStart: boolean;
    onSelect: (workPart: ItemRegistroTiempo, start: boolean) => void;
};

const AzureMapMarkerComponent = (props: IAzureMapMarkerComponentProps) => {
    const [coordinates, setCoordinates] = useState<AzureDataPosition[]>();

    const { mapRef } = useContext<IAzureMapsContextProps>(AzureMapsContext);
    
    useEffect(() => {
        if (props.selectedWorkPart && props.selectedWorkPart.Id === props.workPart.Id) {
            if (props.selectedStart) {
                if (mapRef) {
                    mapRef.setCamera({
                        center: getLatLng(props.selectedWorkPart.PosicionGPSInicio),
                    });
                }
            }
            else {
                if (mapRef) {
                    mapRef.setCamera({ 
                        center: getLatLng(props.selectedWorkPart.PosicionGPSFinal),
                    });
                }
            }
        }
    }, [props.selectedWorkPart, props.selectedStart, props.workPart.Id, mapRef]);

    useEffect(() => {
        if (props.workPart.PosicionGPSInicio && props.workPart.PosicionGPSFinal) {
            const azureDataPositionInicio : AzureDataPosition = getLatLng(props.workPart.PosicionGPSInicio);
            const azureDataPositionFin : AzureDataPosition = getLatLng(props.workPart.PosicionGPSFinal);

            var url = "https://atlas.microsoft.com/route/directions/json?&api-version=1.0"
                + "&query=" + azureDataPositionInicio[0] + "," + azureDataPositionInicio[1] + ":" 
                + azureDataPositionFin[0] + "," + azureDataPositionFin[1]
                + "&subscription-key=3Qqlzj_T3oymm37vAdIMIs2H4jUbPZXxtbkHg03LONw"

            fetch(url).then((response: any) => {
                return response.json();
            }).then((response: any) => {
                if (response.routes && response.routes.length) {
                    var route = response.routes[0];
                    var routeCoordinates: AzureDataPosition[] = [];
                    for (var legIndex = 0; legIndex < route.legs.length; legIndex++) {
                        var leg = route.legs[legIndex];
                        var legCoordinates = leg.points.map((point: any) => {
                            return [
                                point.latitude,
                                point.longitude,
                            ];
                        });
                        routeCoordinates = routeCoordinates.concat(legCoordinates);
                    }
                    setCoordinates(routeCoordinates);
                }
                else {
                    setCoordinates([
                        azureDataPositionInicio,
                        azureDataPositionFin,
                    ]);
                }
            });
        }
        else {
            setCoordinates(undefined);
        }
    }, [props.workPart.PosicionGPSInicio, props.workPart.PosicionGPSFinal]);
    
    return (
        <>
            {
                props.workPart.PosicionGPSInicio ? (
                    <>
                        <AzureMapHtmlMarker
                            events={[{
                                eventName: "click",
                                callback: () => {
                                    props.onSelect(props.workPart, true);
                                },
                            }]}
                            options={{
                                color: "#ed6d63",
                                htmlContent: props.workPart.Descripcion,
                                position: getLatLng(props.workPart.PosicionGPSInicio),
                            }} />
                        <AzureMapPopup 
                            isVisible={props.selectedStart && props.selectedWorkPart?.Id === props.workPart.Id}
                            options={{
                                position: getLatLng(props.workPart.PosicionGPSInicio),
                            }}
                            popupContent={
                                <div style={{
                                    padding: 10,
                                }}>
                                    <Icon iconName='Play' />
                                    <br/>
                                    <Text variant="medium">
                                        <strong>
                                            {props.workPart.IdUsuario}
                                        </strong>
                                    </Text>
                                    <br/>
                                    <Text>
                                        {props.workPart.CodigoCliente}
                                    </Text>
                                    <br/>
                                    <Text>
                                        OT: {props.workPart.IdOrden}
                                    </Text>
                                    <br/>
                                    <Text variant="xSmall">
                                        {props.workPart.Inicio}
                                    </Text>
                                    <br/>
                                    <Text>
                                        {props.workPart.Descripcion}
                                    </Text>
                                </div>
                            } />
                    </>
                ) : (
                    null
                )
            }
            {
                props.workPart.PosicionGPSFinal ? (
                    <>
                        <AzureMapHtmlMarker 
                            events={[{
                                eventName: "click",
                                callback: () => {
                                    props.onSelect(props.workPart, false);
                                },
                            }]}
                            options={{
                                color: "#ed6d63",
                                htmlContent: props.workPart.Descripcion,
                                position: getLatLng(props.workPart.PosicionGPSFinal),
                            }} />
                        <AzureMapPopup 
                            isVisible={!props.selectedStart && props.selectedWorkPart?.Id === props.workPart.Id}
                            options={{
                                position: getLatLng(props.workPart.PosicionGPSFinal),
                            }}
                            popupContent={
                                <div style={{
                                    padding: 10,
                                }}>
                                    <Icon iconName='Pause' />
                                    <br/>
                                    <Text variant="medium">
                                        <strong>
                                            {props.workPart.IdUsuario}
                                        </strong>
                                    </Text>
                                    <br/>
                                    <Text>
                                        {props.workPart.CodigoCliente}
                                    </Text>
                                    <br/>
                                    <Text>
                                        OT: {props.workPart.IdOrden}
                                    </Text>
                                    <br/>
                                    <Text variant="xSmall">
                                        {props.workPart.Fin}
                                    </Text>
                                    <br/>
                                    <Text>
                                        {props.workPart.Descripcion}
                                    </Text>
                                </div>
                            } />
                    </>
                ) : (
                    null
                )
            }
            {
                coordinates ? (
                    <>
                        <AzureMapLayerProvider
                            id={'AzureMapLayerProvider'}
                            options={{
                                strokeWidth: 5,
                                strokeColor: "#ed6d63",
                            }}
                            lifecycleEvents={{
                                layeradded: (e: any) => {
                                    console.log('LAYER ADDED TO MAP', e);
                                },
                            }}
                            type={'LineLayer'} />
                        <AzureMapFeature
                            key={'Line String Feature'}
                            id={'Line String ID'}
                            type={'LineString'}
                            coordinates={coordinates} />
                    </>
                ) : (
                    null
                )
            }
        </>
    );
};

export default AzureMapMarkerComponent;
